import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'react-hot-toast'
import { AdminAuthProvider } from './context/AdminAuthContext'
import AdminLayout from './components/layout/AdminLayout'
import ProtectedRoute from './components/ProtectedRoute'

// Pages
import AdminLogin from './pages/AdminLogin'
import Dashboard from './pages/Dashboard'
import Orders from './pages/Orders'
import Products from './pages/Products'
import Customers from './pages/Customers'
import Invites from './pages/Invites'
import Reports from './pages/Reports'
import Settings from './pages/Settings'
import Promotions from './pages/Promotions'
import Forecasting from './pages/Forecasting'
import SalesHistory from './pages/SalesHistory'
import Scheduler from './pages/Scheduler'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 3,
    },
  },
})

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AdminAuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public */}
            <Route path="/login" element={<AdminLogin />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />

            {/* Protected admin routes */}
            <Route
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/products" element={<Products />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/invites" element={<Invites />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/forecasting" element={<Forecasting />} />
              <Route path="/sales-history" element={<SalesHistory />} />
              <Route path="/scheduler" element={<Scheduler />} />
              <Route path="/promotions" element={<Promotions />} />
              <Route path="/settings" element={<Settings />} />
            </Route>

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>

          <Toaster
            position="top-right"
            toastOptions={{
              duration: 3000,
              style: {
                fontFamily: '"Public Sans", sans-serif',
                fontSize: '13px',
                borderRadius: '10px',
                padding: '10px 14px',
                background: '#1a1a1a',
                color: '#e8e8e8',
                border: '1px solid #2a2a2a',
              },
              success: {
                iconTheme: { primary: '#0e947a', secondary: 'white' },
              },
              error: {
                iconTheme: { primary: '#dc2626', secondary: 'white' },
              },
            }}
          />
        </BrowserRouter>
      </AdminAuthProvider>
    </QueryClientProvider>
  )
}
